<template>
	<div class="container">
		<Navigation-bar>
			<template slot="title">
				<div class="selector_switch-nav" v-if="isFixed" @click="openSelector()">
					<span>筛选</span>
					<YD-image src="icon/icon_下拉箭头_黑色_向下"></YD-image>
				</div>
			</template>
            <template slot="action">
                <YD-image src="icon/icon_search_black" class="search" @click.native="go2Search"></YD-image>
			</template>
		</Navigation-bar>
		<div class="container_content">
			<Scroll :scroll.sync="scrollTop" @scrollEnd="scrollEnd()">
				<Title>
					<template slot="spreadhead">
						<div class="selector_switch" @click="openSelector()">
							<span>筛选</span>
							<YD-image src="icon/icon_下拉箭头_黑色_向下"></YD-image>
						</div>
					</template>
					<template slot="subtitle">
						{{selected.text}}
					</template>
				</Title>
				<div class="data_info">
					<div class="data_info-fixed" :class="{'fixed': isFixed}" :style="dataInfoStyle">
						<div class="selected_text">
							{{selected.text}}
						</div>
						<div class="data_result">
							<div>共<span>{{allCount}}</span>名{{selected.eventsName}}裁判员</div>
						</div>
					</div>
				</div>
				<div class="list">
					<div class="list_item" v-for="(item,index) in list" :key="index" @click="go2Detail(item.RefereeId)">
						<div class="item-portrait">
							<img :src="item.PortraitPhoto" v-if="item.PortraitPhoto">
							<img class="default" :src="getPortraitDefault(item.Gender)" v-else>
                            <div class="sign" v-if="item.NewestUpdateFlag"></div>
						</div>
						<div class="item-body">
							<div class="item-name">{{item.Name}}</div>
							<div class="item-location">
								<template v-if="item.AddressInfo.Country == '中国'">
									<template v-if="item.AddressInfo.Region">{{item.AddressInfo.Region.RegionName || '未知'}}</template>
                                    <template v-else>未知</template>
								</template>
								<template v-else>{{item.AddressInfo.Country || '未知'}}</template>
							</div>
							<div class="item-level">{{item.EventsName}}{{item.CurrentLevelName || ''}}裁判员</div>
						</div>
					</div>
				</div>
				<Text-prompt noDataImg="no_data/暂无内容@2x.png" :text="loadMore"></Text-prompt>
			</Scroll>
		</div>
		<ConditionSelector 
			ref="selector"
			type="referee"
			:form.sync="selectorForm"
			:isFixed="isFixed"
			@search="getDataList(true)"
		></ConditionSelector>
	</div>
</template>

<script>
	import utils from '@js/utils';
	import ConditionSelector from './components/ConditionSelector.vue';
	import {
		GetRefereeList
	} from '@/api';
	export default {
		name: "RefereeCenter",
		components: {
			ConditionSelector
		},
		data(){
			return {
				scrollTop: 0,
				selectorForm: {
					eventsId: 0,
					eventsName: "不限",
					level: 0,
					levelName: "不限",
					gender: 0,
					genderName: "不限",
					provinceCode: 0,
					provinceName: "不限"
				},
				allCount: 0,
				list: [],
				loadMore: ""
			}
		},
		created() {
			this.getDataList(true);
		},
		computed:{
			navBarHeight(){
				return utils.getNavBarHeight();
			},
			titleHeight(){
				return utils.getTitleHeightWithInt();
			},
			isFixed(){
				return this.titleHeight < this.scrollTop;
			},
			dataInfoStyle(){
				return this.isFixed ? {
					top: this.navHeight,
					...this.shadow
				} : {}
			},
			shadow(){
				return utils.setScrollShadow(true);
			},
			selected(){
				let form = this.selectorForm;
				let arr = [];
				if(form.eventsId){
					arr.push(form.eventsName);
				}
				if(form.level){
					arr.push(form.levelName);
				}
				if(form.gender){
					arr.push(form.genderName);
				}
				if(form.provinceCode){
					arr.push(form.provinceName);
				}
				return {
					eventsName: form.eventsId != 0 ? form.eventsName : '',
					text: arr.length ? arr.join(' · ') : '项目 · 级别 · 性别 · 地区'
				}
			},
			/// 获取赛事中最后一个Id
			lastId() {
				let length = this.list.length;
				if (length > 0) {
					return this.list[length - 1].RefereeId;
				}
				return 0;
			}
		},
		methods:{
			getPortraitDefault(gender){
				if(gender == 2){
					return require("@/assets/occupation/images/list_portrait_default_woman@2x.png");
				}
				return require("@/assets/occupation/images/list_portrait_default_man@2x.png");
			},
			scrollEnd(){
				this.getDataList();
			},
			getDataList(isReload = false){
				if(!isReload && ['到底了', '加载中'].includes(this.loadMore)) return;
				this.loadMore = "加载中";
				let lastId = isReload ? 0 : this.lastId;
				let form = this.selectorForm;
				let param = {
					EventsId: form.eventsId,
					LevelNo: form.level,
					Gender: form.gender,
					ProvinceCode: form.provinceCode,
					Keyword: "",
					Continuation: {
						LastId: lastId,
						MaxCount: 20
					}
				};
				GetRefereeList(param).then((data) => {
					this.loadMore = "加载更多";
					if (data.Code === 0) {
						this.allCount = data.AllCount;
						let list = data.ContinueList || [];
                        if(isReload){
							this.scrollTop = 0;
                        }
                        if(list.length == 0){
							if(isReload){
								this.list = [];
								this.loadMore = "无数据";
							}else{
								this.loadMore = '到底了';
							}
						}else{
							if(isReload) {
								this.list =  list;
								if(list.length < 20){
									this.loadMore = '';
								}
							}else {
								this.list.push(...list);
                                if(this.list.length == this.allCount){
                                    this.loadMore = "到底了";
                                }
							}
						}
					}
				});
			},
			go2Search(){
				this.$navigation.go('/Occupation/RefereeSearch');
			},
			openSelector(){
				this.$refs.selector.show();
			},
            go2Detail(id){
                this.$navigation.go(`/Occupation/RefereeDetail/${id}`);
            }
		}
	}
</script>

<style lang="scss" scoped>
	@import "@/assets/occupation/scss/refereeCenter.scss";
</style>